export const QuickAddEnum = {
  Contact: {
    key: 1,
    id: 'quickAddContactId',
    icon: 'icons i-contact',
    value: 'contact',
    permissionsId:'42d5eec5-0833-450d-9614-08da36560604',
  },
  Property: {
    key: 2,
    id: 'quickAddPropertyId',
    icon: 'icons i-property',
    value: 'property',
    permissionsId:'c071d27e-2b8b-4740-9615-08da36560604',
  },
  Unit: {
    key: 3,
    id: 'quickAddUnitId',
    icon: 'icons i-unit',
    value: 'unit',
    permissionsId:'6e68b036-1095-494e-9616-08da36560604',
  },
  Lead: {
    key: 4,
    id: 'quickLeadId',
    icon: 'icons i-lead',
    value: 'lead',
    permissionsId:'e8917429-90e1-4919-9617-08da36560604',
  },
  Activity: {
    key: 5,
    icon: 'icons i-activity',
    id: 'quickActivityId',
    value: 'activity',
    permissionsId:'d6d74217-23f8-4f4a-9618-08da36560604',
  },
  Task: {
    key: 6,
    icon: 'icons i-task',
    id: 'quickTaskId',
    value: 'task',
    permissionsId:'e95f02e0-9f43-4888-19be-08dc313da57c',
  },
};
